/** =========================================================
 * Dashboard controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-dashboard')
    .controller('DashboardController', DashboardController);

  DashboardController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$q', '$translate', '$anchorScroll', '$location', 'ngDialog'];

  function DashboardController($rootScope, $scope, $api, $state, $stateParams, $q, $translate, $anchorScroll, $location, ngDialog) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page dashboard',
        data: {
          filters: $stateParams.filters
        }
      });

      var filters = function () {
        if (typeof $location.search().id !== 'undefined') {
          return [{
            'attr': 'where',
            'name': '',
            'value': [['id', '=', $location.search().id]]
          }];
        }

        return angular.copy($stateParams.filters);
      };

      var getProjectPartActStatus = function (projectPart) {
        try {
          var type = null;

          projectPart.project_part_acts.forEach(function (projectPartAct) {
            type = projectPartAct.type;
          });

          return type;
        } catch (error) {
          Raven.captureException(error);
        }

        return null;
      };

      var getProjectActStatus = function (project) {
        try {
          var type = null;

          project.project_acts.forEach(function (projectAct) {
            type = projectAct.type;
          });

          return type;
        } catch (error) {
          Raven.captureException(error);
        }

        return null;
      };

      var archiveProject = function (project, stack, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to archive project?';
          dialogScope.description = project.uid + ' ' + project.name;

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            $api.update({
              model: 'project',
              data: {
                id: project.id,
                archived: true
              }
            }).then(function () {
              stack.splice(index, 1);
            });
          });
        } catch (error) {
          Raven.captureException(error);
        }
      };

      var sortableOptions = {
        stop: function (e, ui) {
          try {
            for (var index in ui.item.sortable.sourceModel) {
              if (index) {
                ui.item.sortable.sourceModel[index].row_id = parseInt(index, 10);
              }
            }
          } catch (error) {
            Raven.captureException(error);
          }
        },
        uiOrderBy: 'row_id',
        axis: 'y'
      };

      vm.tableConfig = {
        model: 'project',
        getDataParams: {
          order: {
            created_at: 'desc'
          },
          with: [{
            project_type: ['id', 'name', 'slug']
          }, {
            user: ['id', 'name']
          }, {
            customer: ['id', 'name']
          }, {
            contractor: ['id', 'name']
          }, {
            projector: ['id', 'name']
          }, {
            projector_employee: ['id', 'name']
          }, {
            projector_employee_certificate: ['id', 'uid', 'name', 'issue_date']
          },
          'project_parts.project_part_type&user&project_part_acts',
          'project_acts.project_part_acts&project_documents&project_indicators&project_approves',
          'project_documents',
          'project_indicators',
          'project_approves',
          'project_files'
          ],
          where: [
            ['archived', '=', false]
          ],
          pagination_limit: 100
        },
        filters: filters(),
        fields: [{
          title: 'ID',
          key: 'uid',
          order: true
        }, {
          title: 'Type',
          key: 'project_type_id',
          order: true
        }, {
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Customer',
          key: 'customer_id',
          order: true
        }, {
          title: 'Projector',
          key: 'projector_id',
          order: true
        }, {
          title: 'Responsible user',
          key: 'user_id',
          order: true
        }, {
          title: 'Deadline',
          key: 'deadline',
          order: true
        }, {
          title: 'Received',
          key: 'received',
          order: true
        }, {
          title: 'Date',
          key: 'created_at',
          order: true
        }],
        helpers: {
          getProjectPartActStatus: getProjectPartActStatus,
          getProjectActStatus: getProjectActStatus,
          archiveProject: archiveProject,
          sortableOptions: sortableOptions,
          hasPermissionTo: $rootScope.helpers.hasPermissionTo,
          moment: moment
        }
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
